import React from 'react'
import { useTranslation } from 'react-i18next'
import ModalComponent from 'components/common/ModalComponent'
import SelectComponent from 'components/common/SelectComponent'
import DurationInput from 'components/common/DurationInput'
import WorkerTypeahead from 'components/common/WorkerTypeahead'

const StickersModal = ({
  isOpen,
  onClose,
  onSave,
  selectedSticker,
  stickerTypes,
  reusePolicies,
  containers,
  workers
}) => {
  const { t } = useTranslation()
  if (!isOpen) return null

  const isEdit = !!selectedSticker

  return (
    <ModalComponent
      isOpen={isOpen}
      onClose={onClose}
      title={isEdit ? t('mgmt.stickerModal.updateTitle') : t('mgmt.stickerModal.createTitle')}
      initialData={{
        stickerType: selectedSticker?.stickerType || '',
        quantity: selectedSticker?.quantity || '',
        reusePolicy: selectedSticker?.reusePolicy || '',
        containerId: selectedSticker?.containerId || '',
        workerId: selectedSticker?.workerId || 0,
        resetMode: selectedSticker?.resetEvery ? 'interval' : 'daily',
        resetTime: selectedSticker?.resetTime || '',
        resetEvery: selectedSticker?.resetEvery || ''
      }}
      onSave={onSave}
    >
      {({ formData, handleChange }) => (
        <div className='space-y-4'>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <label className='block'>
              <span className='text-sm font-medium'>{t('mgmt.stickerModal.stickerType')}</span>
              <SelectComponent
                name='stickerType'
                value={formData.stickerType || ''}
                onChange={handleChange}
              >
                <option key='' value='' disabled>{t('mgmt.common.selectOption')}</option>
                {Object.values(stickerTypes).map(type => (
                  <option key={type} value={type}>{type}</option>
                ))}
              </SelectComponent>
            </label>
            {formData.stickerType !== stickerTypes.BOX && (
              <label className='block'>
                <span className='text-sm font-medium'>{t('mgmt.stickerModal.worker')}</span>
                <WorkerTypeahead
                  id='workerId'
                  name='workerId'
                  workers={workers}
                  value={formData.workerId}
                  onChange={handleChange}
                />
              </label>
            )}
            <label className='block'>
              <span className='text-sm font-medium'>{t('mgmt.stickerModal.reusePolicy')}</span>
              <SelectComponent
                id='reusePolicy'
                name='reusePolicy'
                value={formData.reusePolicy || ''}
                onChange={handleChange}
              >
                <option key='' value='' disabled>{t('mgmt.common.selectOption')}</option>
                {Object.values(reusePolicies).map(policy => (
                  <option key={policy} value={policy}>{policy}</option>
                ))}
              </SelectComponent>
            </label>
            <label className='block'>
              <span className='text-sm font-medium'>{t('mgmt.stickerModal.containerType')}</span>
              <SelectComponent
                id='containerId'
                name='containerId'
                value={formData.containerId || ''}
                onChange={handleChange}
              >
                <option key='' value='' disabled>{t('mgmt.common.selectOption')}</option>
                {containers.map(container => (
                  <option key={container.containerId} value={container.containerId}>{container.containerName}</option>
                ))}
              </SelectComponent>
            </label>
            <label className='block'>
              <span className='text-sm font-medium'>{t('mgmt.stickerModal.amount')}</span>
              <input
                type='number'
                name='quantity'
                value={formData.quantity || ''}
                onChange={handleChange}
                disabled={isEdit}
                className='mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:outline-none disabled:opacity-60'
              />
            </label>
            {/* Box stickers reset at a daily hour or after an interval; Personal stickers only after an interval */}
            {formData.stickerType === stickerTypes.BOX && (
              <label className='block'>
                <span className='text-sm font-medium'>{t('mgmt.stickerModal.resetMode')}</span>
                <SelectComponent
                  id='resetMode'
                  name='resetMode'
                  value={formData.resetMode}
                  onChange={handleChange}
                >
                  <option value='daily'>{t('mgmt.stickerModal.resetModeDaily')}</option>
                  <option value='interval'>{t('mgmt.stickerModal.resetModeInterval')}</option>
                </SelectComponent>
              </label>
            )}
            {formData.stickerType !== stickerTypes.PERSONAL && !(formData.stickerType === stickerTypes.BOX && formData.resetMode === 'interval') && (
              <label className='block'>
                <span className='text-sm font-medium'>{t('mgmt.stickerModal.resetTime')}</span>
                <input
                  type='time'
                  name='resetTime'
                  value={formData.resetTime || ''}
                  onChange={handleChange}
                  className='mt-1 block w-full p-2 border rounded-md shadow-sm focus:ring focus:ring-opacity-50 focus:outline-none'
                />
              </label>
            )}
            {(formData.stickerType !== stickerTypes.BOX || formData.resetMode === 'interval') && (
              <div>
                <span className='text-sm font-medium'>{t('mgmt.stickerModal.resetEvery')}</span>
                <DurationInput
                  name='resetEvery'
                  value={formData.resetEvery || ''}
                  onChange={handleChange}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </ModalComponent>
  )
}

export default StickersModal
